import Guid from '_shared/guids/guid';

export default class ForumSubscriberInvitationCommand {
  public inviteeId: string;
  public invitationMessage?: string;

  public constructor(inviteeId: Guid, invitationMessage?: string) {
    this.inviteeId = inviteeId.value;
    this.invitationMessage = invitationMessage;
  }
};
